/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/display-name */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Toast from 'react-native-toast-message';

import * as Layout from '@components/screen/Layout';
import Button from '@components/form/Button';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';
import { isWeb, fullWidth, isMobileWeb } from '@global/screens';
import {
  hasNoAccess,
  isQuotationAmountDiff,
  isVn,
  exportPdf,
  getSalesOrderExpiryReminder,
} from '@global/helpers';
import Image from '@components/global/Image';
import Photo from '@components/global/Photo';
import Alert from '@components/global/Alert';
import ItemDetail from '@components/global/ItemDetail';
import ModalCancel from '@components/modal/ModalCancel';
import StatusBadge from '@components/global/StatusBadge';
import ReminderNotice from '@components/global/ReminderNotice';
import OrderHeader from '@/screens/transaction/sales-order/components/OrderHeader';
import OrderLines from '@/screens/transaction/sales-order/components/OrderLines';
import MoreButton from '@components/navbar/MoreButton';
import FloatCommentButton from '@components/comment/FloatCommentButton';
import CommentHeaderButton from '@components/comment/CommentHeaderButton';
import CommentDrawer from '@components/comment/CommentDrawer';

import useApi from '@/hooks/useApi';
import { MsOrder } from '@api/ms-order';
import { MsAccount } from '@api/ms-account';
import { MsB2b } from '@api/ms-b2b';
import { showAlert, setTempData } from '@/store/global';
import { showPopup } from '@/store/modal';
import CheckBox from '@components/form/CheckBox';

const imageSize = 40;
const trash = {
  width: 13,
  height: 17,
};
const limit = 10;
const img = require('@/assets/img/default/user-image.png');

const SalesOrderDetailScreen = (props) => {
  const userData = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  // re-render on language change so the translated expiry reminder copy follows it
  useSelector((state) => state.language.selected);
  const userRole = auth?.user?.role?.code;
  const [activeTab, setActiveTab] = useState(1);
  const [detailData, setDetailData] = useState({});
  const [detailCustomer, setDetailCustomer] = useState({});
  const [showComments, setShowComments] = useState(
    props.route.params?.openComments === 'true',
  );
  const [products, setProducts] = useState([]);
  const [totalData, setTotalData] = useState({
    invoices: 0,
    deliveries: 0,
  });
  const [skip, setSkip] = useState(0);
  const [minimumOrder, setMinimumOrder] = useState(0);
  const [tabs, setTabs] = useState([
    { key: 1, name: 'Header' },
    { key: 2, name: 'Order Lines' },
  ]);
  const [modalCancel, setModalCancel] = useState(false);
  const [isQuotation, setIsQuotation] = useState(false);
  const [isDeliveryInvoiceDone, setIsDeliveryInvoiceDone] = useState(false);

  const hasAccess = hasNoAccess(
    [
      'vice_president_finance',
      'budget_controller',
      'finance_head',
      'tax_support',
      'billing_supervisor',
      'general_manager_marketing',
      'marketing_admin',
      'marketing_support',
      'beauty_advisor',
      'distributor_manager',
    ].filter(
      (role) =>
        detailData?.status !== 'need_approval' ||
        role !== 'distributor_manager',
    ),
  );

  const hasDuplicateAccess = !hasNoAccess([
    'superadmin',
    'sales_admin',
    'salesman',
    'sales_supervisor',
    'general',
  ]);

  const hasCancelAccess = !hasNoAccess(['superadmin', 'general']);

  const hasRequestConfirmationAccess = !hasNoAccess([
    'superadmin',
    'sales_admin',
    'salesman',
    'sales_supervisor',
    'general',
  ]);

  const canApproval = () => {
    if (detailData?.status == 'need_approval' && detailData?.current_approval) {
      return Boolean(detailData?.current_approval == userRole);
    } else {
      return false;
    }
  };

  const getSalesOrderDetail = useApi(MsOrder.getSalesOrderDetail);

  const getDetail = async (id) => {
    Promise.all([getSalesOrderDetail.request(id)]).then(
      async ([sales_order]) => {
        let result = {};
        if (
          sales_order?.data?.data &&
          Object.keys(sales_order.data.data).length
        ) {
          result = sales_order.data.data;
          setDetailData(result);
          getProductSalesOrder(result._id);
          getProductCountSalesOrder(result._id);
          getInvoiceDelivery(result._id);
          if (result?.customer?.id) {
            getCustomer(result);
          }
          dispatch(setTempData(result.status));
          setIsQuotation(result.is_quotation);
        }
        // getMinimumOrder(result);
      },
    );
  };

  const getMinimumOrder = async (detail = {}, customer) => {
    try {
      const matrix = await MsB2b.getMatrixApproval({
        params: {
          filter: {
            applicable_for: 'sales_order',
          },
        },
      });

      if (matrix?.data?.data?.length) {
        const detailMatrix = matrix.data.data[0];
        if (detailMatrix?.rule?.length) {
          let role = userRole;
          if (detail?.created_by?.role) {
            role = detail.created_by.role;
          }
          const findData = detailMatrix.rule.find(
            (m) =>
              m.applicable_on == role &&
              m?.customer_market_type?.code?.toLowerCase() ==
                customer?.market_type.code?.toLowerCase() &&
              m?.customer_market_type?.business_type?.some(
                (bt) =>
                  bt?.code?.toLowerCase() ==
                  customer?.market_type?.business_type?.code?.toLowerCase(),
              ),
          );
          if (findData?.min_amount) {
            setMinimumOrder(findData.min_amount);
          }
        }
      }
    } catch (error) {
      console.log('error-matrix', error);
    }
  };

  const getProductCountSalesOrder = async (id) => {
    const response = await MsOrder.getProductCountSalesOrder(id);
    if (response?.data?.data) {
      const result = response.data.data;
      setTabs((prevTab) =>
        prevTab.map((t) => {
          if (t.key == 2) {
            return {
              ...t,
              count: result,
            };
          }
          return t;
        }),
      );
    }
  };

  const getProductSalesOrder = async (id, newSkip = 0, keyword = '') => {
    setSkip(newSkip);
    const isMore = newSkip > 0;
    const filter = {};
    if (keyword) {
      filter.name = { $regex: keyword, $options: 'i' };
    }
    const response = await MsOrder.getProductSalesOrder(id, {
      params: {
        filter: filter,
        skip: newSkip,
        limit: limit,
      },
    });
    if (response?.data?.data?.length) {
      const result = response.data.data;
      if (isMore) {
        const old = JSON.parse(JSON.stringify(products));
        const finalResult = old.concat(result);
        setProducts(finalResult);
      } else {
        setProducts(result);
      }
    } else {
      if (!isMore) {
        setProducts([]);
      }
    }
  };

  const getInvoiceDelivery = async (id) => {
    const response = await MsOrder.getSalesOrderInvoiceDelivery(id);
    if (response?.data?.data?._id) {
      const result = response.data.data;

      const isInvoiceExists = result?.invoices?.length ? true : false;
      const isDeliveryDone = result?.deliveries?.length
        ? (result?.deliveries || []).find((d) => d.status == 'Done')
        : false;
      setIsDeliveryInvoiceDone(
        isInvoiceExists || isDeliveryDone ? true : false,
      );

      setTotalData({
        invoices: result?.invoices?.length || 0,
        deliveries: result?.deliveries?.length || 0,
      });
    }
  };

  const getCustomer = async (data) => {
    const response = await MsAccount.getCustomerId(data.customer.id);
    if (response?.data?.data?._id) {
      setDetailCustomer(response.data.data);
      getMinimumOrder(data, response.data.data);
    }
  };

  // remove sales order
  const removeSalesOrder = (data) => {
    dispatch(
      showAlert({
        show: true,
        title: 'Delete Sales Order',
        description:
          'This sales order will be deleted. Do you want to proceed?',
        testID: 'sales-order-detail-delete',
        onCallback: async () => {
          try {
            if (data && data._id) {
              dispatch(showPopup({ name: 'isLoading', value: true }));
              const removeUser = await MsOrder.deleteSalesOrder(data._id);
              if (removeUser && removeUser.data && removeUser.data.data) {
                dispatch(showPopup({ name: 'isLoading', value: false }));
                Toast.show({
                  text1: 'Successfully deleted sales order',
                  type: 'success',
                });
                props.navigation.navigate('SalesOrderScreen');
              } else {
                dispatch(showPopup({ name: 'isLoading', value: false }));
                Toast.show({
                  text1: 'Failed to delete sales order',
                  type: 'error',
                });
              }
            }
          } catch (error) {
            dispatch(showPopup({ name: 'isLoading', value: false }));
            Toast.show({ text1: 'A system error occurred', type: 'error' });
          }
        },
      }),
    );
  };

  const onCancelReasonUpdate = async (id, cancelled_reason) => {
    await MsOrder.updateReasonCancelled(id, {
      cancelled_reason: cancelled_reason,
      cancelled_by: {
        _id: userData._id || '',
        name: userData?.name || '',
        role: {
          id: userData?.role?.id || '',
          code: userData?.role?.code || '',
          name: userData?.role?.name || '',
        },
      },
    });
  };

  // change status sales order
  const doChange = async (id, status, force = false) => {
    try {
      if (id) {
        // Check is order spreading
        if (
          detailData.type == 'spreading' &&
          status == 'need_approval' &&
          detailData.attachments.length == 0
        ) {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({ text1: 'Attachment is required', type: 'error' });
          return;
        }

        // check oos product and sync the products
        if (!force) {
          const check_stock = await MsOrder.checkOrderProductOos(id);
          if (
            status == 'approved' &&
            check_stock?.data?.data?.is_out_of_stock &&
            !['transfer'].includes(detailData.type)
          ) {
            dispatch(
              showAlert({
                show: true,
                title: 'Confirm Sales Order',
                descriptionComponent: (
                  <SociollaText style={{ lineHeight: 16 }}>
                    There are{' '}
                    <SociollaText
                      style={{ color: Colors.red0, lineHeight: 16 }}>
                      product out of stock
                    </SociollaText>
                    . Do you want to proceed?
                  </SociollaText>
                ),
                testID: 'sales-order-detail-confirm-oos',
                onCallback: async () => {
                  let syncSuccess = false;
                  try {
                    if (status == 'approved') {
                      await MsOrder.syncOrderProductOos(id);
                    }
                    syncSuccess = true;
                  } catch (errorSync) {
                    console.log('sync-err', errorSync);
                    syncSuccess = false;
                  }
                  if (syncSuccess) {
                    doChange(id, status, true);
                  } else {
                    dispatch(
                      showAlert({
                        show: true,
                        title: 'Error',
                        description: 'Failed to sync sales order product.',
                        isConfirm: false,
                        testID: 'sales-order-detail-sync-error',
                      }),
                    );
                  }
                },
              }),
            );
            return;
          }
        }

        // if all sales order data already filled
        if (
          status == 'need_approval'
            ? detailData?.customer?.id &&
              detailData?.invoice_address?.id &&
              detailData?.delivery_address?.id &&
              detailData?.user?.id &&
              detailData?.expiration_date &&
              detailData?.price_list?.id &&
              detailData?.customer_po_number &&
              detailData?.customer_po_date &&
              detailData?.delivered_at
            : true
        ) {
          dispatch(showPopup({ name: 'isLoading', value: true }));
          const payload = {};
          const requestConfirm = await MsOrder.updateSalesOrderStatus(
            id,
            status,
            payload,
          );
          if (
            requestConfirm &&
            requestConfirm.data &&
            requestConfirm.data.data
          ) {
            dispatch(showPopup({ name: 'isLoading', value: false }));
            let title = '';
            let desc = '';
            if (status == 'need_approval') {
              title = 'Sales Order Submitted';
              desc = 'Sales order submitted and need confirmation';
            } else if (status == 'cancelled') {
              title = 'Sales Order Cancelled';
              desc = 'Sales order has been cancelled';
            } else if (status == 'approved') {
              title = 'Sales Order Confirmed';
              desc = 'Sales order has been confirmed';
            } else if (status == 'draft') {
              title = 'Sales Order Submitted';
              desc = 'Sales order has been drafted';
            }
            dispatch(
              showAlert({
                show: true,
                title: title,
                description: desc,
                isConfirm: false,
                testID: 'sales-order-detail-status-success',
                onCallback: () => {
                  if (
                    status == 'need_approval' &&
                    props?.route?.params?.activityId &&
                    props?.route?.params?.taskId
                  ) {
                    goToActivity();
                  } else {
                    getDetail(props.route.params.id);
                  }
                },
              }),
            );
          } else {
            dispatch(showPopup({ name: 'isLoading', value: false }));
            Toast.show({ text1: 'A system error occurred', type: 'error' });
          }
        } else {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'Please fill in all mandatory data before submit',
            type: 'error',
          });
        }
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      // Toast.show({ text1: error?.response?.data?.message, type: 'error' });
      dispatch(
        showAlert({
          show: true,
          title: 'Error',
          description:
            error?.response?.data?.message || 'A system error occurred',
          isConfirm: false,
          testID: 'sales-order-detail-status-error',
        }),
      );
    }
  };

  // show popup confirmation when we need changing the status
  const changeStatus = async (data, status, force = false) => {
    if (data._id) {
      let title = '';
      let desc = '';
      if (status == 'need_approval') {
        title = 'Request Confirmation';
        desc = 'This sales order will be requested. Do you want to proceed?';
      } else if (status == 'cancelled') {
        title = 'Cancel Sales Order';
        desc = 'This sales order will be cancelled. Do you want to proceed?';
      } else if (status == 'approved') {
        title = 'Confirm Sales Order';
        desc = 'This sales order will be approved. Do you want to proceed?';
      } else if (status == 'draft') {
        title = 'Set to Quotation';
        desc =
          'This sales order will be set to quotation. Do you want to proceed?';
      }
      dispatch(
        showAlert({
          show: true,
          title: title,
          description: desc,
          testID: 'sales-order-detail-change-status',
          onCallback: () => {
            doChange(data._id, status, force);
          },
        }),
      );
    }
  };

  // export pdf for existing sales order
  const handleExportPdf = async (id) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    if (id) {
      try {
        await exportPdf('order', id);
        dispatch(showPopup({ name: 'isLoading', value: false }));
      } catch (err) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    } else {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  };

  const onDuplicate = async (id) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const duplicateSalesOrder = await MsOrder.duplicateSalesOrder(id);
      if (duplicateSalesOrder?.data?.data?._id) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        props.navigation.replace('SalesOrderFormScreen', {
          id: duplicateSalesOrder.data.data._id,
          name: detailData?.customer?.name ? detailData.customer.name : '-',
          titleScreen: detailData.reference_code
            ? detailData.reference_code
            : '-',
        });
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'Failed to duplicate order', type: 'error' });
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: error?.response?.data?.message || 'A system error occurred',
        type: 'error',
      });
    }
  };

  const onCancel = () => {
    if (isDeliveryInvoiceDone) {
      Toast.show({
        text1: 'Unable to cancel because the delivery has been processed',
        type: 'error',
      });
    } else {
      setModalCancel(true);
    }
  };

  const goToActivity = () => {
    props.navigation.navigate('SalesActivityNavigator', {
      screen: 'SalesActivityScreen',
      params: {
        id: props.route.params.activityId,
        direct: 'orders',
      },
    });
  };

  useEffect(() => {
    if (
      props?.route?.params?.isCancelled &&
      detailData.status == 'approved' &&
      hasCancelAccess
    ) {
      if (isDeliveryInvoiceDone) {
        Toast.show({
          text1: 'Unable to cancel because the delivery has been processed',
          type: 'error',
        });
      } else {
        setModalCancel(true);
      }
    }
  }, [props?.route?.params?.isCancelled]);

  useEffect(() => {
    let mounted = true;
    if (mounted && !props?.route?.params?.isCancelled) {
      setMinimumOrder(0);
      setSkip(0);
      setActiveTab(1);
      setDetailData({});
      setDetailCustomer({});
      setProducts([]);
      dispatch(setTempData(null));
      if (props?.route?.params?.id) {
        getDetail(props.route.params.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  useEffect(() => {
    if (!isWeb) {
      const menus = [];
      if (
        hasAccess &&
        !['need_approval', 'approved', 'cancelled'].includes(detailData.status)
      ) {
        menus.push({
          type: 'redirect',
          name: 'Edit',
          screen: 'SalesOrderFormScreen',
          params: { ...props.route.params, firstAdded: '' },
        });
      }
      menus.push({
        type: 'function',
        name: 'Download PDF',
        callback: () => handleExportPdf(detailData._id),
      });
      if (
        (['approved'].includes(detailData.status) && hasCancelAccess) ||
        (hasAccess &&
          ['quotation', 'need_approval'].includes(detailData.status))
      ) {
        menus.push({
          type: 'function',
          name: 'Cancel',
          callback: () => onCancel(),
        });
      }
      if (hasAccess && ['draft'].includes(detailData.status)) {
        menus.push({
          type: 'function',
          name: 'Delete',
          callback: () => removeSalesOrder(detailData),
        });
      }
      if (
        ['approved', 'need_approval', 'rejected', 'cancelled'].includes(
          detailData.status,
        ) &&
        hasDuplicateAccess &&
        detailData.type != 'spreading'
      ) {
        menus.push({
          type: 'function',
          name: 'Duplicate',
          callback: () => onDuplicate(detailData._id),
        });
      }

      props.navigation.setOptions({
        headerRight: () => (
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            {!isWeb && detailData._id ? (
              <CommentHeaderButton
                onPress={() => setShowComments(true)}
                drawerVisible={showComments}
                entityType="sales_order"
                entityId={detailData._id}
              />
            ) : (
              false
            )}
            <MoreButton
              testID="sales-order-detail-more-button"
              menu={menus}
              {...props}
            />
          </View>
        ),
      });
    }
  }, [props, detailData, isDeliveryInvoiceDone, showComments]);

  const hasFooter = Boolean(
    !isWeb &&
      ((detailData.status == 'need_approval' && canApproval()) ||
        detailData.status === 'approved' ||
        detailData.status == 'draft' ||
        detailData.status == 'quotation'),
  );

  const isDisabledRequestConfirmation = useMemo(() => {
    if (isQuotation) {
      const productDiffer = products.find(
        (p) =>
          isQuotationAmountDiff(
            p.total_price_before_tax,
            p.quotation_total_price_before_tax,
            true,
          ) ||
          isQuotationAmountDiff(p.total_price, p.quotation_total_price, true),
      );
      if (
        isQuotationAmountDiff(
          detailData.subtotal,
          detailData.quotation_subtotal,
          true,
        ) ||
        isQuotationAmountDiff(
          detailData.total_tax_amount,
          detailData.quotation_tax,
          true,
        ) ||
        isQuotationAmountDiff(
          detailData.total_amount,
          detailData.quotation_total,
          true,
        ) ||
        productDiffer
      ) {
        return true;
      }
      return false;
    }

    const isSignatureMissing = isVn()
      ? false
      : !detailData?.signatures?.salesman?.url;

    return detailData?.subtotal < minimumOrder || isSignatureMissing;
  }, [detailData, minimumOrder, isQuotation, products]);

  const handleUpdateSignatures = (newSignatures) => {
    setDetailData((prev) => ({
      ...prev,
      signatures: newSignatures,
    }));
  };

  const User = (userProps) => {
    return (
      <View
        style={{
          flex: 1,
          flexDirection: 'row',
          justifyContent: 'flex-start',
          ...userProps.style,
        }}
        key={'list-users-' + userProps.index}>
        <Image
          style={{ width: 20, height: 20, marginRight: 8 }}
          width={20}
          height={20}
          isResolveAsset
          source={
            Array.isArray(userProps?.image) && userProps?.image.length > 0
              ? userProps?.image[0]
              : userProps?.image !== ''
              ? userProps?.image
              : img
          }
        />
        <SociollaText
          style={{ fontSize: 12, color: Colors.blue3, alignSelf: 'center' }}>
          {userProps.name}
        </SociollaText>
      </View>
    );
  };

  return (
    <Layout.Container testID="sales-order-detail-screen">
      {isWeb && (
        <Layout.Back
          title={props.route.params?.isTask ? 'Task' : 'Sales Order'}
          onCallback={() => {
            const returnTo = props?.route?.params?.returnTo;
            if (returnTo?.navigator && returnTo?.screen) {
              props.navigation.navigate(returnTo.navigator, {
                screen: returnTo.screen,
                params: returnTo.params,
              });
              return;
            }
            if (
              props?.route?.params?.activityId &&
              props?.route?.params?.taskId
            ) {
              goToActivity();
              return;
            }
            props.navigation.navigate('SalesOrderScreen', {
              id: '',
              name: '',
              titleScreen: '',
            });
          }}
        />
      )}
      <Layout.Wrapper rounded>
        {getSalesOrderDetail.loading ? (
          <Layout.Loader />
        ) : detailData && Object.keys(detailData).length ? (
          <>
            <Layout.ScrollViewRefresher
              isFullHeight
              hasFooter={hasFooter}
              onCallback={() => getDetail(props?.route?.params?.id)}>
              <ReminderNotice
                banner
                testID="sales-order-detail-expiry-reminder"
                title={getSalesOrderExpiryReminder(detailData)}
              />
              <View style={styles.sectionWrapper}>
                <View
                  style={[
                    styles.rowContainer,
                    {
                      position: 'relative',
                      zIndex: 1,
                      justifyContent: 'space-between',
                    },
                  ]}>
                  <View
                    style={[
                      styles.rowContainer,
                      {
                        width: '100%',
                        maxWidth: isWeb
                          ? `calc(100% - ${imageSize + 45 + 200}px)`
                          : fullWidth - 85,
                      },
                    ]}>
                    <Photo
                      width={imageSize}
                      height={imageSize}
                      image={
                        Array.isArray(detailData?.customer?.image) &&
                        detailData?.customer?.image.length > 0
                          ? detailData?.customer?.image[0]
                          : detailData?.customer?.image !== ''
                          ? detailData?.customer?.image
                          : require('@assets/img/default/user-default.png')
                      }
                    />
                    <SociollaText
                      type="medium"
                      style={{
                        fontSize: 20,
                        maxWidth: isWeb
                          ? `calc(100% - ${imageSize + 45}px)`
                          : fullWidth - 85,
                      }}>
                      {detailData.customer && detailData.customer.name
                        ? detailData.customer.name
                        : '-'}
                    </SociollaText>
                  </View>
                  {isWeb && (
                    <View
                      style={[styles.rowContainer, { position: 'relative' }]}>
                      {(['approved'].includes(detailData.status) &&
                        hasCancelAccess) ||
                      (hasAccess &&
                        ['quotation', 'need_approval'].includes(
                          detailData.status,
                        )) ? (
                        <Button
                          testID="sales-order-detail-cancel-btn"
                          type="primary"
                          rounded
                          buttonStyle={{ width: 90, marginRight: 10 }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{ color: Colors.white }}>
                              Cancel
                            </SociollaText>
                          }
                          onPress={onCancel}
                        />
                      ) : (
                        false
                      )}
                      {[
                        'approved',
                        'need_approval',
                        'rejected',
                        'cancelled',
                      ].includes(detailData.status) &&
                      hasDuplicateAccess &&
                      detailData.type != 'spreading' ? (
                        <Button
                          testID="sales-order-detail-duplicate-btn"
                          type="primary"
                          rounded
                          buttonStyle={{ width: 90, marginRight: 10 }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{ color: Colors.white }}>
                              Duplicate
                            </SociollaText>
                          }
                          onPress={() => {
                            onDuplicate(detailData._id);
                          }}
                        />
                      ) : (
                        false
                      )}
                      {
                        // show edit button when status is not need approval, approved and cancelled
                        hasAccess &&
                        !['need_approval', 'approved', 'cancelled'].includes(
                          detailData.status,
                        ) ? (
                          <Button
                            testID="sales-order-detail-edit-btn"
                            type="primary"
                            rounded
                            buttonStyle={{ width: 80, marginRight: 10 }}
                            title={
                              <SociollaText
                                type="bold"
                                style={{ color: Colors.white }}>
                                Edit
                              </SociollaText>
                            }
                            onPress={() =>
                              props.navigation.replace('SalesOrderFormScreen', {
                                id: detailData._id,
                                name:
                                  detailData.customer &&
                                  detailData.customer.name
                                    ? detailData.customer.name
                                    : '-',
                                titleScreen: detailData.reference_code
                                  ? detailData.reference_code
                                  : '-',
                                order_type: detailData.type,
                                ...(props?.route?.params?.activityId &&
                                props?.route?.params?.taskId
                                  ? {
                                      activityId: props.route.params.activityId,
                                      taskId: props.route.params.taskId,
                                    }
                                  : {}),
                              })
                            }
                          />
                        ) : (
                          false
                        )
                      }
                      <Button
                        testID="sales-order-detail-pdf-btn"
                        type="primary"
                        rounded
                        buttonStyle={{ width: 42, marginRight: 10 }}
                        title={
                          <Image
                            style={{
                              width: trash.width,
                              height: trash.height,
                            }}
                            width={trash.width}
                            height={trash.height}
                            source={require('@assets/img/icons/pdf.png')}
                          />
                        }
                        onPress={() => handleExportPdf(detailData._id)}
                      />
                      {
                        // show remove button when status is
                        hasAccess && ['draft'].includes(detailData.status) ? (
                          <Button
                            testID="sales-order-detail-delete-btn"
                            type="primary"
                            rounded
                            buttonStyle={{ width: 42 }}
                            title={
                              <Image
                                style={{
                                  width: trash.width,
                                  height: trash.height,
                                }}
                                width={trash.width}
                                height={trash.height}
                                source={require('@assets/img/icons/trash-white.svg')}
                                svg={true}
                              />
                            }
                            onPress={() => removeSalesOrder(detailData)}
                          />
                        ) : (
                          false
                        )
                      }
                      {
                        // show confirm button when status is need approval and user role is superadmin or branch head
                        detailData.status == 'need_approval' &&
                        canApproval() ? (
                          <View
                            style={{
                              position: 'absolute',
                              right: 0,
                              left: 0,
                              bottom: -50,
                            }}>
                            <Button
                              testID="sales-order-detail-confirm-btn"
                              rounded
                              buttonStyle={{ width: '100%' }}
                              title={
                                <SociollaText
                                  type="bold"
                                  style={{
                                    fontSize: 14,
                                    lineHeight: 17,
                                    color: Colors.white,
                                  }}>
                                  Confirm
                                </SociollaText>
                              }
                              onPress={() =>
                                changeStatus(detailData, 'approved')
                              }
                            />
                          </View>
                        ) : (
                          false
                        )
                      }
                      {
                        // show request confirmation button when status is draft
                        hasAccess &&
                        hasRequestConfirmationAccess &&
                        ['draft', 'quotation'].includes(detailData.status) ? (
                          <View
                            style={{
                              position: 'absolute',
                              right: 0,
                              left: 0,
                              bottom: -50,
                            }}>
                            <Button
                              testID="sales-order-detail-request-confirmation-btn"
                              rounded
                              buttonStyle={{ width: '100%' }}
                              disabledStyle={{ width: '100%' }}
                              disabled={isDisabledRequestConfirmation}
                              title={
                                <SociollaText
                                  type="bold"
                                  style={{
                                    fontSize: 14,
                                    lineHeight: 17,
                                    color: Colors.white,
                                    textAlign: 'center',
                                  }}>
                                  Request Confirmation
                                </SociollaText>
                              }
                              onPress={() =>
                                changeStatus(detailData, 'need_approval')
                              }
                            />
                          </View>
                        ) : (
                          false
                        )
                      }
                    </View>
                  )}
                </View>
                <View style={{ paddingVertical: 15 }}>
                  <ItemDetail
                    name="Order Number"
                    value={detailData.reference_code}
                  />
                  <ItemDetail
                    name="Status"
                    centered
                    value={<StatusBadge status={detailData.status} />}
                  />
                  {detailData?.status == 'need_approval' &&
                  detailData.waiting_approvals?.length ? (
                    <ItemDetail
                      name="Waiting Approval"
                      withoutBorder={true}
                      valueComponent={
                        <View style={{ flexDirection: 'column' }}>
                          {detailData.waiting_approvals.map((appr, index) => (
                            <User
                              name={appr.name || ''}
                              image={appr.image || ''}
                              key={'list-user-approval-' + index}
                              index={index}
                              style={{ paddingBottom: 10 }}
                            />
                          ))}
                        </View>
                      }
                    />
                  ) : (
                    false
                  )}
                  <ItemDetail
                    name="Invoice Status"
                    centered
                    value={<StatusBadge status={detailData.invoice_status} />}
                  />
                  {detailData.type != 'spreading' ? (
                    <ItemDetail
                      name="Clearance"
                      centered
                      valueComponent={
                        <CheckBox
                          checked={detailData?.is_clearance ? true : false}
                        />
                      }
                    />
                  ) : (
                    false
                  )}
                  <ItemDetail
                    name="Notes"
                    centered
                    value={detailData?.notes ? detailData.notes : '-'}
                  />
                </View>
              </View>
              {/* Start Tab Container */}
              <View
                style={[
                  styles.rowContainer,
                  styles.rowBorderBottom,
                  {
                    justifyContent: isWeb ? 'flex-start' : 'space-around',
                  },
                ]}>
                {tabs.map((item, idx) => (
                  <TouchableOpacity
                    testID={`sales-order-detail-tab-${idx}`}
                    activeOpacity={0.6}
                    style={[
                      styles.tabItem,
                      activeTab == item.key ? styles.tabItemActive : {},
                      isWeb ? { width: 160 } : { width: '50%' },
                    ]}
                    key={item.key}
                    onPress={() => setActiveTab(item.key)}>
                    <SociollaText
                      style={[
                        styles.tabText,
                        activeTab == item.key ? styles.tabTextActive : {},
                        { alignSelf: 'center' },
                      ]}>
                      {item.name || ''}
                      {item.count !== undefined ? ` (${item.count})` : ''}
                    </SociollaText>
                  </TouchableOpacity>
                ))}
              </View>
              {/* End Tab Container */}
              <View
                style={[
                  styles.sectionWrapper,
                  {
                    padding: 0,
                    paddingBottom: ['draft', 'quotation'].includes(
                      detailData.status,
                    )
                      ? 55
                      : 0,
                  },
                  isWeb ? { overflow: 'auto' } : {},
                  hasFooter ? { marginBottom: 70 } : {},
                ]}>
                {/* Start Header Tab Content */}
                {activeTab == 1 ? (
                  <OrderHeader
                    detailData={detailData}
                    detailCustomer={detailCustomer}
                    totalData={totalData}
                    onUpdateSignatures={handleUpdateSignatures}
                    getDetail={getDetail}
                    {...props}
                  />
                ) : (
                  false
                )}
                {/* End Header Tab Content */}

                {/* Start Order Lines Tab Content */}
                {activeTab == 2 ? (
                  <View style={{ height: '100%' }}>
                    <OrderLines
                      isQuotation={isQuotation}
                      detailData={detailData}
                      products={products}
                      skip={skip}
                      limit={limit}
                      onLoadMore={({ keyword, skip }) => {
                        getProductSalesOrder(detailData?._id, skip, keyword);
                      }}
                      onSearch={({ keyword }) => {
                        getProductSalesOrder(detailData?._id, 0, keyword);
                      }}
                      {...props}
                    />
                    {isMobileWeb && <View style={{ height: 300 }} />}
                  </View>
                ) : (
                  false
                )}
                {/* End Order Lines Tab Content */}
              </View>
            </Layout.ScrollViewRefresher>
            {!getSalesOrderDetail.loading ? (
              <>
                {
                  // show confirm button when status is need approval and user role is superadmin or branch head
                  !isWeb &&
                    detailData.status == 'need_approval' &&
                    canApproval() && (
                      <Layout.ButtonSticky
                        testID="sales-order-detail-confirm-btn-mobile"
                        show={
                          props?.route?.name == 'SalesOrderDetailScreen' &&
                          Boolean(detailData?._id)
                        }
                        route={props?.route}
                        buttons={[
                          {
                            title: 'Confirm',
                            onPress: () => changeStatus(detailData, 'approved'),
                          },
                        ]}
                      />
                    )
                }
                {
                  // show request confirmation button when status is draft
                  !isWeb &&
                    hasAccess &&
                    hasRequestConfirmationAccess &&
                    ['draft', 'quotation'].includes(detailData.status) && (
                      <Layout.ButtonSticky
                        testID="sales-order-detail-request-confirmation-btn-mobile"
                        show={
                          props?.route?.name == 'SalesOrderDetailScreen' &&
                          Boolean(detailData?._id)
                        }
                        route={props?.route}
                        buttons={[
                          {
                            title: 'Request Confirmation',
                            disabled: isDisabledRequestConfirmation,
                            onPress: () =>
                              changeStatus(detailData, 'need_approval'),
                          },
                        ]}
                      />
                    )
                }
                {
                  // show return button when status is  approved and user role is superadmin or branch head
                  !isWeb &&
                  hasAccess &&
                  hasRequestConfirmationAccess &&
                  detailData.status == 'approved' ? (
                    <Layout.ButtonSticky
                      testID="sales-order-detail-return-order-btn-mobile"
                      show={
                        props?.route?.name == 'SalesOrderDetailScreen' &&
                        Boolean(detailData?._id)
                      }
                      buttons={[
                        {
                          title: 'Return Order',
                          onPress: () =>
                            props.navigation.navigate('ReturnOrderNavigator', {
                              screen: 'ReturnOrderFormScreen',
                              params: {
                                titleScreen: detailData?.reference_code
                                  ? detailData?.reference_code
                                  : '-',
                                name:
                                  detailData?.customer &&
                                  detailData?.customer.name
                                    ? detailData?.customer.name
                                    : '-',
                                id: detailData?._id,
                                data: detailData,
                                isSales: true,
                              },
                            }),
                        },
                      ]}
                    />
                  ) : (
                    false
                  )
                }
              </>
            ) : (
              false
            )}
          </>
        ) : (
          <View style={{ width: '100%', padding: 20 }}>
            <SociollaText>No data found.</SociollaText>
          </View>
        )}
      </Layout.Wrapper>
      <Alert />
      {modalCancel && (
        <ModalCancel
          show={modalCancel}
          onClose={() => {
            if (props?.route?.params?.isCancelled) {
              props.navigation.setParams({ isCancelled: undefined });
            }
            setModalCancel(false);
          }}
          onSubmit={(cancelled_reason) => {
            try {
              onCancelReasonUpdate(detailData._id, cancelled_reason);
              setModalCancel(false);
              doChange(detailData._id, 'cancelled', true);
              if (isWeb) {
                getDetail(detailData._id);
              }
            } catch (error) {
              console.log('error update reason', error);
            }
          }}
        />
      )}
      {detailData._id ? (
        <>
          {isWeb ? (
            <FloatCommentButton
              onPress={() => setShowComments(true)}
              drawerVisible={showComments}
              entityType="sales_order"
              entityId={detailData._id}
            />
          ) : (
            false
          )}
          <CommentDrawer
            visible={showComments}
            onClose={() => setShowComments(false)}
            entityType="sales_order"
            entityId={detailData._id}
            entityRef={detailData.reference_code}
          />
        </>
      ) : (
        false
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  sectionWrapper: { width: '100%', padding: 15 },
  rowContainer: { flexDirection: 'row', alignItems: 'center' },
  rowBorderBottom: { borderBottomColor: Colors.grey0, borderBottomWidth: 1 },
  tabItem: {
    paddingVertical: 15,
    paddingHorizontal: 20,
    borderBottomWidth: 3,
    borderBottomColor: 'transparent',
  },
  tabItemActive: {
    borderBottomColor: Colors.blue0,
  },
  tabText: {
    fontSize: 14,
  },
  tabTextActive: {
    color: Colors.blue0,
    fontFamily: 'figtree-medium',
  },
});

export default SalesOrderDetailScreen;
